<template lang="pug">
  .w-full.relative
    .absolute.inset-0.flex.items-center.w-10(v-if='$slots.default')
      slot
    input.w-full(
      :ref="_uid"
      :class="customClasses"
      :data-purpose="dataPurposeProp"
      :placeholder="placeholder"
      :min="minValue"
      :max="maxValue"
      :type="type"
      :value="value"
      @blur="$emit('blur')"
      @focus="$emit('focus')"
      @input="$emit('input', $event.target.value)"
    )
</template>

<script>
export default {
  name: 'SwInput',
  props: {
    customClasses: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: null,
    },
    type: {
      type: String,
      default: 'string',
    },
    placeholder: {
      type: String,
      default: null,
    },
    minValue: {
      type: Number,
      default: 0,
    },
    maxValue: {
      type: Number,
      default: 10000000,
    },
    dataPurposeProp: {
      type: String,
      default: '',
    },
  },
  mounted () {
    if (this.type === 'date') {
      // These attributes, that we apply only on inputs of type date, are not
      // any kind of validation: their only purpose is to limit the amount of
      // 'year' digits that can be inputted to 4 (the default being 6), for better
      // UX and prevent observed difficulties to type the year for some users.
      const input = this.$refs[this._uid];
      input.setAttribute('max', '2100-12-31');
      input.setAttribute('min', '1900-01-01');
    }
  },
};
</script>
